// Auto-discovers every certificate track under ./records/*.json, the same
// way src/data/classes does for classes. To publish a new certificate page
// (e.g. /BlackBeltCertificate), drop a new .json file here with a matching
// `slug` — no route needs to be declared in App.jsx.
import { classRegistry } from '../classes';

const modules = import.meta.glob('./records/*.json', { eager: true });

export const certificateTypeRegistry = {};

for (const path in modules) {
  const record = modules[path].default;
  if (record && record.slug) {
    certificateTypeRegistry[record.slug.toLowerCase()] = record;
  }
}

export function getCertificateType(slug) {
  if (!slug) return undefined;
  return certificateTypeRegistry[slug.toLowerCase()];
}

// Holders are class participants tagged with this certificate's slug, same
// idea as getCredential() in src/data/classes: no separate roster to keep
// in sync, a participant just needs `name` + `certificateSlug` set.
//
// PRIVACY: this function backs the public /verify page's certificate
// tables. It must never return a participant's name, or any other
// personally identifying field. See "Public page privacy" in CLAUDE.md
// before changing this — the private, name-inclusive roster is tracked
// separately in PRIVATE_REGISTRY_PLAN.md and isn't built yet.
export function getCertificateHolders(slug) {
  const type = getCertificateType(slug);
  if (!type) return [];

  const holders = [];
  for (const classRecord of Object.values(classRegistry)) {
    for (const participant of classRecord.participants) {
      if (participant.name && participant.certificateSlug?.toLowerCase() === type.slug.toLowerCase()) {
        holders.push({
          recordId: participant.id,
          hrs: participant.hrs,
          pct: participant.pct,
          classId: classRecord.id,
          certificationProject: participant.certificationProject,
        });
      }
    }
  }
  return holders;
}
